export const GET_CMS_LEVEL_NODE_INFO = 'GET_CMS_LEVEL_NODE_INFO';
export const SET_CMS_CONTENT_LIST = 'SET_CMS_CONTENT_LIST';

//CARRUSELES
export const DELETE_CONTINUE_VIEWING_ITEM = 'DELETE_CONTINUE_VIEWING_ITEM';
export const REMOVE_MY_LIST_ITEM = 'REMOVE_MY_LIST_ITEM';

//MODAL CONFIRMACION DE BORRADO
export const SHOW_DELETE_CONFIRMATION_MODAL = 'SHOW_DELETE_CONFIRMATION_MODAL';
export const HIDE_DELETE_CONFIRMATION_MODAL = 'HIDE_DELETE_CONFIRMATION_MODAL';
export const SET_CONTENT_NAME = 'SET_CONTENT_NAME';
export const SET_CONTENT_TYPE = 'SET_CONTENT_TYPE';
export const SET_DELETE_CALLBACK = 'SET_DELETE_CALLBACK';
export const SET_CANCEL_CALLBACK = 'SET_CANCEL_CALLBACK';
export const DELETE_POSTER_RECORDING = 'DELETE_POSTER_RECORDING';
